import {get} from 'lodash';

export default (state = {}, {coachId, coach}: any) => {
  return {
    ...state,
    allProfiles: {
      ...get(state, 'allProfiles', {}),
      [coachId]: coach,
    },
  };
};
